import React from 'react';

import { DATA_SALES_URL } from 'global-constants';

import Button from 'shared/components/Button';
import Checkpoint from 'shared/components/Checkpoint';
import ExternalLink from 'shared/components/ExternalLink';

import styles from './styles.module.scss';

const ATTRIBUTES = [
  { text: 'Custom Data Sets' },
  { text: 'Export to CSV' },
  { text: 'API Connections' }
];

const EnterprisePlan = () => (
  <div className={styles.container}>
    <div className={styles.heading}>Enterprise</div>
    <div className={styles.attributes}>
      {ATTRIBUTES.map(item => (
        <Checkpoint iconClassNames={styles.icon}>{item.text}</Checkpoint>
      ))}
    </div>
    <ExternalLink href={DATA_SALES_URL} className={styles.btnContainer}>
      <Button color="primary" className={styles.btn}>
        Book a Call
      </Button>
    </ExternalLink>
  </div>
);

export default EnterprisePlan;
